import { Injectable } from '@angular/core';
import * as moment from 'moment/moment';

@Injectable()
export class DateService {

  constructor(
  ) {
    moment.locale('ja');
  }

  get now(): number {
    return Math.floor(new Date().getTime() / 1000);
  }

  toTimestamp(date: string): number {
    return Math.floor(new Date(date).getTime() / 1000);
  }

  toFormatYMD(date: string, format: string): string {
    return moment(date).format("YYYY" + format + "MM" + format + "DD");
  }

  toFormatYMDHIS(value:number): string {
    if (!value || value === 0) {
      return '-';
    }
    const now = new Date(value * 1000);
    return now.getFullYear() + '/' +  ( "0"+( now.getMonth()+1 ) ).slice(-2)+ '/' + ( "0"+now.getDate() ).slice(-2) + '  ' + ( "0" + now.getHours() ).slice(-2) + ':' + ( "0" + now.getMinutes()).slice(-2);
  }

  getRelativeTime(targetDateStr:any, baseDateStr = null) {

    let baseDate = (baseDateStr) ? new Date(baseDateStr) : new Date();
    let targetDate = new Date(targetDateStr);
    let elapsedTime = Math.ceil((baseDate.getTime() - targetDate.getTime())/1000);
    let message = null;

    // これ以下で一定時間未満のごとのメッセージの表示方法を条件分岐
    // 表示する数字が1桁のときは関数 digit で頭に半角スペースを付ける
    if (elapsedTime < 60) { //  1 分未満
      message =  'たった今';
    } else if (elapsedTime < 120) { //  2 分未満
      message =  '1分前';
    } else if (elapsedTime < (60*60)) { //  1 時間未満
      message =  '' + (Math.floor(elapsedTime / 60) < 10 ? ' ' : '') + Math.floor(elapsedTime / 60) + '分前';
    } else if (elapsedTime < (120*60)) { //  2 時間未満
      message =  '1時間前';
    } else if (elapsedTime < (24*60*60)) { //  1 日未満
      message =  '' + (Math.floor(elapsedTime / 3600) < 10 ? ' ' : '') + Math.floor(elapsedTime / 3600) + '時間前';
    } else if (elapsedTime < (7*24*60*60)) { // 1 週間未満
      message =  '' + (Math.floor(elapsedTime / 86400) < 10 ? ' ' : '') +Math.floor(elapsedTime / 86400) + '日前';
    } else { // 1 週間以上
      message =  '' + (Math.floor(elapsedTime / 604800) < 10 ? ' ' : '') + Math.floor(elapsedTime / 604800) + '週間前';
    }
    return message;
  }


  getDayList(count: number, ) {
    let start = moment();
    let dayList = [];
    for (let i =0; i<count; i++) {
      let date = start.format('YYYY-MM-DD');
      dayList.push(date)
      start.subtract(1, 'days');
//      start.add(1, 'days');
    }
    return dayList;
  }
}



// WEBPACK FOOTER //
// ./src/providers/date.service.ts